import { useEffect, useState } from "react";
import { BarChart3 } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

const BOT_LABELS = {
  hilo_bot: "📈 High Low 24/7",
  rocket_bot: "🚀 Rocket 24/7",
  heli_ride: "🚀 Rocket (manual)",
  auto_burst: "⚡ Auto Burst",
  auto_bot: "🤖 Auto Bot",
  over3_bot: "🎯 Over 3 Recovery",
  forex_bot: "🌍 Auto-FX 24/7",
  wheel: "🎡 Wheel",
  risefall_momentum: "📈 Rise/Fall Momentum",
  pro_trade: "📊 Pro Trade",
  manual: "🖐 Manual trades",
};

const MyBotStats = ({ accountId }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!accountId) return;
    let dead = false;
    fetch(`${API}/api/bot-stats/${encodeURIComponent(accountId)}?days=90`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (!dead) setData(d); })
      .catch(() => {});
    return () => { dead = true; };
  }, [accountId]);

  const bots = data?.bots || [];

  return (
    <div data-testid="my-bot-stats" className="rounded-xl border border-vts-line bg-vts-card p-4 space-y-3">
      <div className="flex items-center gap-2">
        <BarChart3 className="h-4 w-4 text-sky-400" />
        <div>
          <p className="text-sm font-semibold text-white">My Real Results — last 90 days</p>
          <p className="text-[10px] text-vts-silver/50 font-mono">
            Your OWN settled trades per bot — not estimates. Demo results are labeled and never mixed with real.
          </p>
        </div>
      </div>

      {!accountId && (
        <p data-testid="my-bot-stats-noacct" className="text-[10px] font-mono text-vts-silver/50">Connect Deriv to see your per-bot results.</p>
      )}
      {accountId && data && bots.length === 0 && (
        <p data-testid="my-bot-stats-empty" className="text-[10px] font-mono text-vts-silver/50">No settled trades yet in the last 90 days — run a bot and your real numbers will appear here.</p>
      )}

      {bots.length > 0 && (
        <div className="space-y-1.5">
          <div className="grid grid-cols-[1fr_auto_auto_auto] gap-x-3 text-[8px] uppercase tracking-wider text-vts-silver/45 font-mono px-2">
            <span>Bot</span><span className="text-right">W / L</span><span className="text-right">Win rate</span><span className="text-right">Net</span>
          </div>
          {bots.map((b, i) => (
            <div
              key={`${b.source}-${b.is_demo}-${i}`}
              data-testid={`my-bot-stats-row-${b.source}${b.is_demo ? "-demo" : ""}`}
              className="grid grid-cols-[1fr_auto_auto_auto] gap-x-3 items-center rounded-lg border border-vts-line/40 bg-vts-surface/40 px-2 py-1.5"
            >
              <span className="text-[10px] font-mono text-white truncate">
                {BOT_LABELS[b.source] || b.source}
                {b.is_demo && <span className="ml-1.5 rounded border border-amber-400/40 px-1 text-[8px] text-amber-300">DEMO</span>}
              </span>
              <span className="text-right text-[10px] font-mono text-vts-silver/70">{b.wins} / {b.losses}</span>
              <span className={`text-right text-[10px] font-mono font-bold ${b.win_rate >= 0.5 ? "text-vts-profit" : "text-vts-silver/70"}`}>
                {(b.win_rate * 100).toFixed(0)}%
              </span>
              <span className={`text-right text-[10px] font-mono font-bold ${b.net >= 0 ? "text-vts-profit" : "text-vts-loss"}`}>
                {b.net >= 0 ? "+" : ""}${b.net.toFixed(2)}
              </span>
            </div>
          ))}
          <p className="text-[8px] font-mono text-vts-silver/40 px-2">
            Past results don't predict future ones — small samples swing hard either way.
          </p>
        </div>
      )}
    </div>
  );
};

export default MyBotStats;
